module.exports = __webpack_public_path__ + "static/media/hn.d5440b3d.svg";